import { render, staticRenderFns } from "./PageModalForm.vue?vue&type=template&id=0522724b"
import script from "./PageModalForm.vue?vue&type=script&lang=js"
export * from "./PageModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports